<template>
    <!-- Email input field -->
    <div :class="emailInputClass">
        <label
            v-if="showLabel"
            class="input__label"
            :class="{ 'required-input': mandatory }"
            for="email-address"
            v-text="label || $t('ACCOUNT_FORM_EMAIL')"/>
        <input
            id="email-address"
            name="email"
            autocomplete="email"
            autocapitalize="off"
            :disabled="disabled"
            type="email"
            :placeholder="placeholder"
            class="input__field"
            @blur="onBlur"
            v-model.trim="email">

        <!-- Validation -->
        <p class="input__message"
           v-if="message"
           v-text="message"/>
        <p class="input__message"
           v-else-if="errorHandler.has('email')"
           v-text="$t(errorHandler.get('email'))"/>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import EmailService from '@/services/users/EmailService';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';

let emailService = new EmailService();
export default {
    name: 'EmailAddressField',
    props: {
        value: {
            default: null,
            type: String,
        },
        label: {
            default: null,
            type: String,
        },
        shouldValidate: {
            default: false,
            type: Boolean,
        },
        message: {
            required: false,
            type: String,
            default: null,
        },
        isValid: {
            default: true,
            type: Boolean,
        },
        mandatory: {
            default: false,
            type: Boolean,
        },
        showLabel: {
            default: true,
            type: Boolean,
        },
        disabled: {
            default: false,
            type: Boolean,
        },
        placeholder: {
            default: '',
            type: String,
        },
    },
    data() {
        return {
            email: this.value,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    computed: {
        emailInputClass() {
            if (this.value === null && this.isEmailValid === true) {
                return 'input';
            }

            return this.isEmailValid ? 'input input--success' : 'input input--invalid';
        },

        isEmailValid() {
            return !this.errorHandler.has('email') && this.isValid;
        },
    },
    mounted() {
        this.email = this.value;
        this.$emit('input', this.value);
    },
    methods: {
        validateEmail(value) {
            emailService.isEmailAvailable(value)
                .then(() => {
                    this.errorHandler.reset();
                    this.$emit('error', this.errorHandler);
                })
                .catch(error => {
                    this.errorHandler.setResponse(error.response.data);
                    this.$emit('error', this.errorHandler);
                });
        },
        onBlur(e) {
            const value = e.target.value;
            this.email = value;
            if (this.shouldValidate) {
                this.validateEmail(this.email);
            }
            this.$emit('input', value);
        },
    },
    watch: {
        email: debounce(function(value) {
            this.$emit('input', value);
            this.shouldValidate ? this.validateEmail(value) : false;
        }, 500),
        value: {
            immediate: true,
            handler(value) {
                this.email = value;
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.input__field {
    &::placeholder {
        color: #b3b3b3;
    }
}
</style>
